module.exports = __webpack_public_path__ + "2dc9a918cc8a88ef76174ed213d978c7.png";